export const setCellActivateState = (state, action): any => {
  const updatedState = {
    ...state,
    CellActivate: action.payload.CellActivate,
  };

  return updatedState;
};
